
import { useState, useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

interface GprofileInteractionHistoryProps {
  userId: string;
  displayName: string;
}

const GprofileInteractionHistory = ({ userId, displayName }: GprofileInteractionHistoryProps) => {
  const { user } = useAuth();
  const [lastMessage, setLastMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchLastMessage();
    }
  }, [user, userId]);

  const fetchLastMessage = async () => {
    if (!user) return;

    try {
      const { data, error } = await supabase
        .from('messages')
        .select('content, created_at')
        .or(`and(sender_id.eq.${user.id},receiver_id.eq.${userId}),and(sender_id.eq.${userId},receiver_id.eq.${user.id})`)
        .order('created_at', { ascending: false })
        .limit(1)
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('Error fetching last message:', error);
        return;
      }

      if (data) {
        setLastMessage(data.content);
      }
    } catch (error) {
      console.error('Error fetching last message:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !lastMessage) return null;

  return (
    <div className="px-4 py-6 border-b border-white/10">
      <div className="flex items-start gap-3 p-3 bg-white/5 rounded-lg">
        <MessageCircle className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-1" />
        <div className="flex-1">
          <p className="text-white/60 text-sm mb-1">Last message with {displayName}</p>
          <p className="text-white/90 text-sm line-clamp-2">
            "{lastMessage}"
          </p>
        </div>
      </div>
    </div>
  );
};

export default GprofileInteractionHistory;
